module.exports = __webpack_public_path__ + "img/2-1.0ee75f59.png";